import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Logo from '../logo/Logo'

type IProps = {
  loading: boolean
  title?: string
}

const Loader: FC<IProps> = ({ loading, title }) => {
  const { t } = useTranslation()

  return loading ? (
    <div className='w-screen h-screen fixed right-0 top-0 z-[1000] bg-neutral-100 opacity-70'>
      <div className='w-56 flex items-center flex-col fixed right-1/2 -mr-[120px] top-1/3'>
        <div className='text-blue-500 text-base font-bold'>{title}</div>
        <div className='mt-5 ml-4'>
          <Logo classes='w-auto h-20' />
        </div>
        <div className='w-full h-[6px] rounded-full bg-gray-300 mt-5'>
          <div className='w-1/3 absolute inline-block h-[6px] rounded-full bg-blue-400 animate-loader' />
        </div>
        <div className='text-sm font-bold text-blue-500 mt-5'>{t('pleaseWait')}</div>
      </div>
    </div>
  ) : null
}

export default Loader
